import { showMessages } from '@intercom/messenger-js-sdk';
import { EmptyStatePrimaryAction } from '@synoptic/ui-kit/empty-state/empty-state-primary-action.tsx';
import { EmptyState } from '@synoptic/ui-kit/empty-state/empty-state.tsx';
import { ShareAndroidIcon } from '@synoptic/ui-kit/icons/react/share-android.tsx';
import { useLocation, useNavigate } from 'react-router';
import { StreamQueryType } from '@/__generated__/schema-types.ts';
import { streamsEmptyState } from '@/components/stream-list/empty-streams-feed.css.ts';
import { NewStreamModal } from '@/components/streams/new-stream-modal.tsx';
import { paths } from '@/routes-utils/paths.ts';

export interface EmptyStreamsFeedProps {
  afterSearch?: boolean;
}

export const EmptyStreamsFeed = ({ afterSearch }: EmptyStreamsFeedProps) => {
  const navigate = useNavigate();

  const location = useLocation();
  const isCustomStreams = location.pathname.startsWith(paths.customStreams);

  const streamType =
    location.pathname === paths.streams
      ? StreamQueryType.All
      : location.pathname === paths.streamsFollowing
        ? StreamQueryType.Following
        : StreamQueryType.Created;

  const heading = afterSearch ? 'No streams found' : 'No streams yet';

  const description = afterSearch
    ? 'Check the spelling or try using a different keywords.'
    : streamType === StreamQueryType.All
      ? 'Be the first to create data stream!'
      : streamType === StreamQueryType.Following
        ? "This is where you'll be able to see data streams you follow."
        : streamType === StreamQueryType.Created
          ? "This is where you'll be able to see data streams you created."
          : null;

  const Cta = afterSearch ? (
    <EmptyStatePrimaryAction onClick={showMessages}>
      Request a stream
    </EmptyStatePrimaryAction>
  ) : streamType === StreamQueryType.Following ? (
    <EmptyStatePrimaryAction
      onClick={() => {
        navigate(paths.streams, { replace: true });
      }}
    >
      Explore streams
    </EmptyStatePrimaryAction>
  ) : streamType === StreamQueryType.Created ||
    streamType === StreamQueryType.All ? (
    <NewStreamModal
      key={isCustomStreams ? 'custom-stream-modal' : 'stream-modal'}
      trigger={
        <EmptyStatePrimaryAction>
          {isCustomStreams ? 'Create custom stream' : 'Create stream'}
        </EmptyStatePrimaryAction>
      }
      customStream={isCustomStreams}
    />
  ) : null;

  return (
    <EmptyState
      illustration={<ShareAndroidIcon />}
      heading={heading}
      description={description}
      action={Cta}
      className={streamsEmptyState}
    />
  );
};
